<template>
  <div class="impersonate-user padding-s bg-color-yellow align-center" v-if="isLoggedIn && customer.Impersonated">
    <p class="type-small no-margin">You are currently impersonating {{ customer.FirstName }} {{ customer.LastName }} </p>
  </div>
</template>

<script>

import { mapState } from 'vuex';

export default {
  name: 'ImpersonateUser',
  watch: {
    customer() {
      if( this.customer.Impersonated ){
        document.body.classList.add('js-is-impersonating');
      }else{
        document.body.classList.remove('js-is-impersonating');
      }
    },
  },
  computed: {
    ...mapState({
      customer: state => state.AuthStore.customer,
      isLoggedIn: state => state.AuthStore.isLoggedIn,
    }),
  }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/ImpersonateUser.vue